import React, { useEffect, useState } from 'react'
import FcModuleStyle from '../styles/fc.module.css';
import increase_prediction from '../assets/increase_prediction.png';
import decrease_prediction from '../assets/decrease_prediction.png';

import profit from '../assets/profit.png';
import PastDecision from './PastDecision';
import CurrentDecision from './CurrentDecision';
import askAI1 from '../assets/askAI1.PNG';
import Button from '../../common/Button';
import { expert_opinion} from '../services/api';
import { errorMsg } from '../../../helper/helpers';

const MakeaForecast = ({ pOrderActivityHeight, setPOrderActivityHeight, simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, getMonth, setIsShowPlaceOrder , fcPopup, setFcPopup, skipWalkThruPopups,isOverlay}) => {
    const [isCurrDecisionActive, setIsCurrDecisionActive] = useState(true);
    const [isExpertOpinion, setIsExpertOpinion] = useState(false);
    const [isUtilizedActive, setIsUtilizedActive] = useState(false);
    const [expertOpinion, setExpertOpinion] = useState({});
    const [isAskAi, setIsAskAi] = useState(true);
    const [fcAiPopupTop,setFcAiPopupTop] = useState(0);
    const [fcPricePredPopupTop,setFcPricePredPopupTop] = useState(0);
    const[fcForecastPopupTop, setFcForecastPopupTop] = useState(0);
    const openExpertOpinion  = () =>{ 
        setIsAskAi(false)
        setIsExpertOpinion(true);
        setIsCurrDecisionActive(false);
        const expOpiObj = {
            "id": simObj?.id,
            "userid": simObj?.userid,
            "simulationname": "FC",
            "executioninstanceid": simObj?.executioninstanceid,
            "completed": simObj?.completed,
            "currentstep": simObj?.currentstep
        }
        expert_opinion(expOpiObj, simObj.sessionid).then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else{
            if (typeof response != 'undefined') {
                setExpertOpinion(response?.data);
            }
        }
          }).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
          });
    }
    const changeTabs = (e) => {

        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) {
        const target = window.$(e.target).closest('.item.tab-item')[0];
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.setAttribute("tabindex", "-1");
                t.style.borderBottom = "none";
                t.style.color = "rgba(0,0,0,.6)";
                t.classList.remove(`${FcModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.removeAttribute("tabindex")
        target.style.borderBottom = "2px solid #B90000"
        target.style.color = "#B90000"
        target.classList.add(`${FcModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent
                .querySelectorAll(`#panelList>div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        (target.getAttribute("id") == "tab_1") ? setIsCurrDecisionActive(true) : setIsCurrDecisionActive(false);
        (target.getAttribute("id") == "tab_2") ? setIsUtilizedActive(true) : setIsUtilizedActive(false);

    }
    const handleInvestmentTabs = () => {
        const tabs = document.getElementsByClassName(`${FcModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementsByClassName(`${FcModuleStyle['decision-tabs']}`)[0]

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                changeTabs(e);
                const tabs = document.getElementsByClassName(`${FcModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
                let activeTab = window.$(e.target).closest('.item.tab-item')[0];
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                }, 0)
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        tabList.addEventListener("keydown", (e) => {
            // Move right
            const tabs = document.getElementsByClassName(`${FcModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
            if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                let activeTab = document.getElementsByClassName(`${FcModuleStyle['decision-tabs']}`)[0].querySelector(`[role="tab"].active`)
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                }, 100)
            }
            if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }
                else if (e.key === "Home") {
                    tabFocus = 0;
                }
                else if (e.key === "End") {
                    tabFocus = tabs.length - 1;
                }
                e.preventDefault();
                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
        // tabs[0].click();
    }
    useEffect(() => {
        setPOrderActivityHeight(document.getElementsByClassName(`${FcModuleStyle['make-decision-activity']}`)[0].clientHeight)
        // console.log(simObj?.laststate)
    }, [simObj?.laststate]);
    useEffect(() => {
        handleInvestmentTabs();
    }, []);
    useEffect(() => {
        const handleResize1 = ()=> { 
            if(fcPopup?.forecasteDecision && document.getElementsByClassName(`${FcModuleStyle['forecast-decision-popup']}`)[0] != null){
                let top = document.querySelector("#ActualDemand").clientHeight - document.getElementsByClassName(`${FcModuleStyle['forecast-decision-popup']}`)[0].clientHeight - 10;
                let target = document.getElementsByClassName(`${FcModuleStyle['make-decision-parent']}`)[0];
                target.scrollTo(0,500)
                setFcForecastPopupTop(top);
            }
        }
        window.addEventListener('resize', handleResize1);
        handleResize1();
      }, [fcPopup?.askAi, fcPopup?.pricePrediction, fcPopup?.forecasteDecision]);
    return (
        <div className={`${FcModuleStyle['make-decision-parent']} ${fcPopup?.makeForecast ? `show ${FcModuleStyle['show']}` : ''}`}>
            <div className={`${FcModuleStyle['make-decisions']} ${fcPopup?.forecasteDecision ? `show ${FcModuleStyle['show']}` : ''}`} style={{ borderRight: isAskAi ? "1px solid #DEDEDF" : "" }}>
                 <div className={`${FcModuleStyle['decision-heading']}`}>
                        <img src={profit} alt="" />
                        <h3>Make a Forecast</h3>
                    </div>
                    <div className={`${FcModuleStyle['decision-main']}`} id='decisionMain'>
                        <div role="tablist" aria-label="Investment tabs" className={`${FcModuleStyle['decision-tabs']}`}>
                            <button
                                className={`item tab-item ui button active ${FcModuleStyle['ui']} ${FcModuleStyle['button']}`}
                                role="tab"
                                aria-selected="true"
                                aria-controls="panel_1"
                                id="tab_1"
                                tabIndex="0"
                                onClick={()=>{
                                    if(!isExpertOpinion){setIsAskAi(true)}
                                }}
                                style={{ borderBottom: "2px solid #B90000", color: "#B90000" }}
                            >
                                Current Decision
                            </button>
                            <button
                                className={`item tab-item ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']}`}
                                role="tab"
                                aria-selected="false"
                                aria-controls={`panel_2`}
                                id="tab_2"
                                onClick={()=>setIsAskAi(false)}
                                tabIndex="-1">
                                Past Decision
                            </button>
                        </div>
                        <div id="panelList" className={`${FcModuleStyle['panel-list']}`}>
                            <div id='panel_1' className={`${FcModuleStyle['_panel_1']}`} role="tabpanel" tabIndex="0" aria-labelledby="tab_1">
                                <CurrentDecision simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} setIsShowPlaceOrder={setIsShowPlaceOrder} getMonth={getMonth} setIsCurrDecisionActive={setIsCurrDecisionActive} expertOpinion={expertOpinion} isExpertOpinion={isExpertOpinion} setIsExpertOpinion={setIsExpertOpinion} setIsAskAi={setIsAskAi} fcPopup={fcPopup} setFcPopup={setFcPopup} isOverlay={isOverlay} />
                            </div>
                            <div id="panel_2" role="tabpanel" className={`${FcModuleStyle['panel-2']}`} tabIndex="0" aria-labelledby="tab_2" hidden>
                                <PastDecision simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} isUtilizedActive={isUtilizedActive} getMonth={getMonth} />
                            </div>
                        </div>
                        {/*(isCurrDecisionActive && !isExpertOpinion) && <div className={`${FcModuleStyle["price-prediction"]}`}>
                            <div><strong>Price Prediction: </strong><img src={(simObj?.actions?.FCMakeForeCastOption?.predictedGasPriceMessage == "increase") ? increase_prediction : decrease_prediction} width={30} /><span>Possible {simObj?.actions?.FCMakeForeCastOption?.predictedGasPriceMessage} in {getMonth(simObj?.currentstate?.statemonth) + " " + simObj?.currentstate?.stateyear}</span></div>
                        </div>*/
                        }
                    </div>
            </div>
            { 
            fcPopup?.forecasteDecision ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["forecast-decision-popup"]}`} role='dialog' aria-modal="true" aria-label='Forecast decision popup' tabIndex={-1} style={{top:fcForecastPopupTop+"px"}}>
              <p>When you’re ready, create your forecast for the first month. Forecast all grades of gasoline, then click Submit. Values must be greater than 100.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    window.$("#decisionMain>div:first button:last").click();
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['forecasteDecision'] : false, ['makeForecast']: true }))
                }} />   
              </div>
            </div> : ''
          }


            {
                isAskAi ? 
                <div className={`${FcModuleStyle['ask-user-parent']} `}>
                    <div className={`${FcModuleStyle["ask-user"]}`}>
                                    <div>
                                        <div className={`${FcModuleStyle["ai-inner-div"]} ${fcPopup?.askAi ? `show ${FcModuleStyle['show']}` : ''}`}> 
                                        <h4>Use AI</h4>
                                        <img src={askAI1} alt="" />
                                        {/* <p className={`${FcModuleStyle['chances-remaining']}`}>(<strong>{simObj?.actions?.FCMakeForeCastOption?.remainingAttempts}</strong> chances)</p> */}
                                        <p className={`${FcModuleStyle['chances-remaining']}`}>(<strong>{simObj?.actions?.FCMakeForeCastOption?.remainingAttempts}</strong> {simObj?.actions?.FCMakeForeCastOption?.remainingAttempts == 1 ? 'chance' : 'chances'})</p>
                                        <Button btnName="Answer" disabled={!simObj?.actions?.expertAdviceAvailable || simObj?.completed } btnWidth="140" customBtnStyle={{ background: "transparent", color: "rgb(178, 52, 123)", borderColor: "rgb(178, 52, 123)" }} clickEventHandler={() => openExpertOpinion() } />
                                        </div>
                                        <div className={`${FcModuleStyle['prediction-div']}  ${fcPopup?.pricePrediction ? `show ${FcModuleStyle['show']}` : ''}`}>
                                        <div className={`${FcModuleStyle["price-prediction"]} `}>
                                            <div className={`${FcModuleStyle["price-prediction-child"]}`}>
                                            <span><strong>Price Prediction: </strong>
                                                <img src={(simObj?.actions?.FCMakeForeCastOption?.predictedGasPriceMessage == "increase") ? increase_prediction : decrease_prediction} width={30} alt="" />
                                            <span> Possible {simObj?.actions?.FCMakeForeCastOption?.predictedGasPriceMessage} in {getMonth(simObj?.currentstate?.statemonth) + " " + simObj?.currentstate?.stateyear}</span>
                                                </span>
                                            </div>
                                        </div>
                                        </div>
                                        
                                    </div>
                    </div>
                </div> : ""
            }
        </div>
    )
}

export default MakeaForecast